module.exports = __webpack_public_path__ + "static/media/E_SDG_Icons-15.b50ca54d.jpg";